export default __webpack_public_path__ + "static/media/harvard_cbe_logo.a24e821c.png";